import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "assets/svgs/filters.svg";
import { filterTagsByAttribute, filterBundlesByAttribute } from "utils/filters";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import FiltersPanel from "./panel";
import clsx from "clsx/lite";
import { cartMeals } from "utils/constants";
import { toggleFilterPanel } from "slices/filters";
import { clearFilters, clearBundleFilter, clearFilter } from "slices/filters";

const Filters = ({ filters, hideResults = false, hideTitle = false }) => {
	const { tags, bundles, isSearchOpen } = useSelector((state) => state.filters);
	const { hasOfferBar, view } = useSelector((state) => state.global);
	const dispatch = useDispatch();

	const settledTags = filterTagsByAttribute(tags, "isSettled");
	const settledBundles = filterBundlesByAttribute(bundles, "isSettled");
	const totalSettledFilters = settledTags.length + settledBundles.length;
	const disabled = view === cartMeals;

	useEffect(() => {
		const url = new URL(window.location);

		const updateParam = (key, values, original) => {
			if (values.length) {
				url.searchParams.set(key, values.join(","));
			} else if (Object.keys(original).length) {
				url.searchParams.delete(key);
			}
		};

		updateParam("tags", settledTags, tags);
		updateParam("bundles", settledBundles.map(b => b.title || b), bundles);

		window.history.replaceState({}, "", url);
	}, [tags, settledTags, bundles, settledBundles]);

	return (
		<div className={clsx(
			"hidden items-center justify-between lg:sticky bg-white z-40 py-0",
			hasOfferBar ? "lg:top-[7.5rem]" : "lg:top-16",
			totalSettledFilters === 0 && hideTitle ? "lg:hidden" : "lg:flex", hideTitle && "pt-4"
		)}>
			<div className="relative w-full p-0">
				<div className="flex justify-between items-center w-full h-10">
					{!isSearchOpen && (
						!filters?.data?.length ? <div /> :
							<div className="flex w-full">
								<button disabled={disabled}
									className={clsx("items-center bg-[#F5F5F5] justify-center rounded-full p-3 hidden relative",
										disabled ? "opacity-30 pointer-events-none" : "cursor-pointer hover:bg-dark-gray",
										!hideTitle && "lg:flex"
									)}
									onClick={() => dispatch(toggleFilterPanel())}
								>
									{totalSettledFilters > 0 &&
										<span className="badge -right-2 -top-1">
											{totalSettledFilters}
										</span>}
									<FilterIcon />
									<span className="ml-2">Filter</span>
								</button>
								<div className={clsx("hidden max-w-[80%]", !hideResults && "pr-4 xl:block")}>
									<div className={clsx("min-h-12 min-w-0 flex items-center justify-start bg-white py-1",
										"pointer-events-auto overflow-y-hidden overflow-x-auto md:overflow-x-auto max-w-full h-16"
									)}>
										{settledTags.length > 0 &&
											settledTags.map((a) => (
												<div key={a}
													className={clsx("pill-base", disabled && "opacity-30 pointer-events-none")}>
													<span>{tags[a].displayName}</span>
													<button onClick={() => dispatch(clearFilter(a))}>
														<Close className="w-3 h-3 cursor-pointer" />
													</button>
												</div>
											))}
										{settledBundles.length > 0 &&
											settledBundles.map((bundle) => (
												<div key={bundle}
													className={clsx("pill-base", disabled && "opacity-30 pointer-events-none")}>
													<span>{bundle.title}</span>
													<button
														onClick={() =>
															dispatch(clearBundleFilter(bundle.title))
														}>
														<Close className="w-3 h-3 cursor-pointer" />
													</button>
												</div>
											))}
									</div>
								</div>
								{totalSettledFilters > 0 && !hideResults && (
									<button
										onClick={() => dispatch(clearFilters())}
										className={clsx("hidden lg:flex mt-px underline pt-2.5 pr-7.5 pb-2 pl-5",
											"relative box-border items-center whitespace-nowrap mr-2.5",
											disabled ? "opacity-30 pointer-events-none cursor-none" : "cursor-pointer"
										)}
									>
										{filters.clearFilters}
									</button>
								)}
							</div>
					)}
				</div>
			</div>
			{filters?.data?.length && <FiltersPanel filters={filters} />}
		</div >
	);
};

export default Filters;
